module.exports = __webpack_public_path__ + "static/media/Section.87381a8f.scss";


//////////////////
// WEBPACK FOOTER
// ./src/shared/FormAnswer/Form/Section/Section.scss
// module id = 346
// module chunks = 0